export enum RatingType {
  VeryWeak = 'veryWeak',
  Weak = 'weak',
  Neutral = 'neutral',
  Strong = 'strong',
  VeryStrong = 'veryStrong',
  Blank = 'blank',
}
